/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetThumbnailsQueryResponse, SegmentsGetThumbnailsPathParams, SegmentsGetThumbnailsQueryParams, SegmentsGetThumbnails400, SegmentsGetThumbnails401, SegmentsGetThumbnails403, SegmentsGetThumbnails404 } from "../models/SegmentsGetThumbnails";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { segmentsGetThumbnails } from "../axios/segmentsGetThumbnails";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const segmentsGetThumbnailsQueryKey = (station: SegmentsGetThumbnailsPathParams["station"], params: SegmentsGetThumbnailsQueryParams) => ["api-v2", { url: '/segments/v1/stations/:station/thumbnails', params: {station:station} }, ...(params ? [params] : [])] as const

export type SegmentsGetThumbnailsQueryKey = ReturnType<typeof segmentsGetThumbnailsQueryKey>

export function segmentsGetThumbnailsQueryOptions(station: SegmentsGetThumbnailsPathParams["station"], params: SegmentsGetThumbnailsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = segmentsGetThumbnailsQueryKey(station, params)
        return queryOptions<SegmentsGetThumbnailsQueryResponse, ResponseErrorConfig<SegmentsGetThumbnails400 | SegmentsGetThumbnails401 | SegmentsGetThumbnails403 | SegmentsGetThumbnails404>, SegmentsGetThumbnailsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return segmentsGetThumbnails(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns thumbnail URLs and metadata for video segments that overlap the given time range.
 * @summary List thumbnails for the specified interval
 * {@link /segments/v1/stations/:station/thumbnails}
 */
export function useSegmentsGetThumbnails<TData = SegmentsGetThumbnailsQueryResponse, TQueryData = SegmentsGetThumbnailsQueryResponse, TQueryKey extends QueryKey = SegmentsGetThumbnailsQueryKey>(station: SegmentsGetThumbnailsPathParams["station"], params: SegmentsGetThumbnailsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SegmentsGetThumbnailsQueryResponse, ResponseErrorConfig<SegmentsGetThumbnails400 | SegmentsGetThumbnails401 | SegmentsGetThumbnails403 | SegmentsGetThumbnails404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? segmentsGetThumbnailsQueryKey(station, params)
         

         const query = useQuery({
          ...segmentsGetThumbnailsQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SegmentsGetThumbnails400 | SegmentsGetThumbnails401 | SegmentsGetThumbnails403 | SegmentsGetThumbnails404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}